import axios from '../utils/axios';
import camelcaseKeys from 'camelcase-keys-recursive';
import snakeCaseKeys from "snakecase-keys";

const GET_FUNERAL_HOMES_REQUEST = 'GET_FUNERAL_HOMES_REQUEST';
export const GET_FUNERAL_HOMES_SUCCESS = 'GET_FUNERAL_HOMES_SUCCESS';
export const GET_FUNERAL_HOMES_FAILURE = 'GET_FUNERAL_HOMES_FAILURE';

const GET_FUNERAL_HOME_REQUEST = 'GET_FUNERAL_HOME_REQUEST';
export const GET_FUNERAL_HOME_SUCCESS = 'GET_FUNERAL_HOME_SUCCESS';
export const GET_FUNERAL_HOME_FAILURE = 'GET_FUNERAL_HOME_FAILURE';

const CREATE_FUNERAL_HOME_REQUEST = 'CREATE_FUNERAL_HOME_REQUEST';
export const CREATE_FUNERAL_HOME_SUCCESS = 'CREATE_FUNERAL_HOME_SUCCESS';
export const CREATE_FUNERAL_HOME_FAILURE = 'CREATE_FUNERAL_HOME_FAILURE';

const UPDATE_FUNERAL_HOME_REQUEST = 'UPDATE_FUNERAL_HOME_REQUEST';
export const UPDATE_FUNERAL_HOME_SUCCESS = 'UPDATE_FUNERAL_HOME_SUCCESS';
export const UPDATE_FUNERAL_HOME_FAILURE = 'UPDATE_FUNERAL_HOME_FAILURE';

const DELETE_FUNERAL_HOME_REQUEST = 'DELETE_FUNERAL_HOME_REQUEST';
export const DELETE_FUNERAL_HOME_SUCCESS = 'DELETE_FUNERAL_HOME_SUCCESS';
export const DELETE_FUNERAL_HOME_FAILURE = 'DELETE_FUNERAL_HOME_FAILURE';

export const getFuneralHomes = () => {
  return dispatch => {
    dispatch({ type: GET_FUNERAL_HOMES_REQUEST });
    
    return axios.get('api/funeral_homes', {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    })
      .then(response => {
        const funeralHomes = camelcaseKeys(response.data).funeralHomes;
        dispatch(getFuneralHomesSuccess(funeralHomes));
      })
      .catch(error => dispatch(getFuneralHomesFailure(error)));
  }
};

const getFuneralHomesSuccess = (funeralHomes) => {
  return {
    type: GET_FUNERAL_HOMES_SUCCESS,
    funeralHomes,
  }
};

const getFuneralHomesFailure = (error) => {
  return {
    type: GET_FUNERAL_HOMES_FAILURE,
    error,
  }
};

export const getFuneralHome = (id) => {
  return dispatch => {
    dispatch({ type: GET_FUNERAL_HOME_REQUEST });
    
    return axios.get(`api/funeral_homes/${id}`, {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    })
      .then(response => {
        const funeralHome = camelcaseKeys(response.data).funeralHome;
        dispatch(getFuneralHomeSuccess(funeralHome));
      })
      .catch(error => dispatch(getFuneralHomeFailure(error)));
  }
};

const getFuneralHomeSuccess = (funeralHome) => {
  return {
    type: GET_FUNERAL_HOME_SUCCESS,
    funeralHome,
  }
};

const getFuneralHomeFailure = (error) => {
  return {
    type: GET_FUNERAL_HOME_FAILURE,
    error,
  }
};

export const createFuneralHome = (funeralHome, imagesData) => {
  return dispatch => {
    dispatch({ type: CREATE_FUNERAL_HOME_REQUEST });
    
    const data = snakeCaseKeys({ funeralHome: funeralHome });

    return axios.post('api/funeral_homes', data, {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(response => {
      const funeralHome = camelcaseKeys(response.data).funeralHome;
      const id = funeralHome.id;

      axios.post(`api/funeral_homes/${id}/upload_images`, imagesData, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
      })

      dispatch(createFuneralHomeSuccess(funeralHome));
    })
    .catch(error => {
      if( error.response ){
        dispatch(createFuneralHomeFailure(error.response.data.message));
      } else {
        dispatch(createFuneralHomeFailure("something went wrong"));
      }
    });
  }
};

const createFuneralHomeSuccess = (funeralHome) => {
  return {
    type: CREATE_FUNERAL_HOME_SUCCESS,
    funeralHome,
  }
};

const createFuneralHomeFailure = (message) => {
  return {
    type: CREATE_FUNERAL_HOME_FAILURE,
    message,
  }
};

export const updateFuneralHome = (funeralHome, funeralHomeId) => {
  return dispatch => {
    dispatch({ type: UPDATE_FUNERAL_HOME_REQUEST });
    
    const data = snakeCaseKeys({ funeralHome: funeralHome });

    return axios.put(`api/funeral_homes/${funeralHomeId}`, data, {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(response => {
      const funeralHome = camelcaseKeys(response.data).funeralHome;

      dispatch(updateFuneralHomeSuccess(funeralHome));
    })
    .catch(error => {
      if( error.response ){
        dispatch(updateFuneralHomeFailure(error.response.data.message));
      } else {
        dispatch(updateFuneralHomeFailure("something went wrong"));
      }
    });
  }
};

const updateFuneralHomeSuccess = (funeralHome) => {
  return {
    type: UPDATE_FUNERAL_HOME_SUCCESS,
    funeralHome,
  }
};

const updateFuneralHomeFailure = (message) => {
  return {
    type: UPDATE_FUNERAL_HOME_FAILURE,
    message,
  }
};

export const deleteFuneralHome = (funeralHomeId, history) => {
  return dispatch => {
    dispatch({ type: DELETE_FUNERAL_HOME_REQUEST });

    return axios.delete(`api/funeral_homes/${funeralHomeId}`, {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(response => {
      dispatch(deleteFuneralHomeSuccess(funeralHomeId));
      history.push("/funeralhomes");
    })
    .catch(error => {
      if( error.response ){
        dispatch(deleteFuneralHomeFailure(error.response.data.message));
      } else {
        dispatch(deleteFuneralHomeFailure("something went wrong"));
      }
    });
  }
};

const deleteFuneralHomeSuccess = (funeralHomeId) => {
  return {
    type: DELETE_FUNERAL_HOME_SUCCESS,
    funeralHomeId,
  }
};

const deleteFuneralHomeFailure = (message) => {
  return {
    type: DELETE_FUNERAL_HOME_FAILURE,
    message,
  }
};
